module.exports = __webpack_public_path__ + "img/5cffa2e.jpg";